module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis solicitudes de vacaciones")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isEditing) ? _c('div', {
    key: "list-solicitudes",
    staticClass: "position-relative"
  }, [(_vm.mostrarConfirmacionEnviar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarAprobar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEnviar = false
      },
      "do": _vm.aprobar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea enviar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Enviando...")] : [_vm._v("Enviar")]], 2), _c('span', [_vm._v("Luego de enviar la notificación a su jefe, no podrá modificarlo")])])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazar = false
      },
      "do": _vm.rechazar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), _c('div', {
    staticClass: "show-closed-text"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.showClosed = !_vm.showClosed
      }
    }
  }, [(_vm.showClosed) ? [_vm._v("Mostrando todas las solicitudes")] : [_vm._v("Mostrando solo las solicitudes abiertas")]], 2)]), _c('div', {
    staticClass: "body"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Fecha")]), _c('th', {
    staticClass: "hide-break-1"
  }, [_vm._v("Retorno")]), _c('th', [_vm._v("Estado")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.solicitudes), function(o, index) {
    return (_vm.showClosed || (!_vm.showClosed && o.estadoData.abierto)) ? _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.estadoData.abierto
      }
    }, [_c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('div', {
      staticClass: "dates-wrapper hint--top",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', [_vm._v(_vm._s(o.desde))]), _c('span', {
      staticClass: "hide-break-1"
    }, [_vm._v(" - ")]), _c('span', [_vm._v(_vm._s(o.hasta))])]), _c('div', {
      staticClass: "show-break-1 dates-wrapper"
    }, [_c('span', {
      staticClass: "has-text-bold"
    }, [_vm._v("Retorno:")]), _c('span', [_vm._v(_vm._s(o.retorno))]), _c('span', {
      staticClass: "email"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")])])])]), _c('td', {
      staticClass: "hide-break-1"
    }, [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.retorno) + " ")]), _c('span', {
      staticClass: "email"
    }, [_vm._v("(" + _vm._s(o.dias) + " días)")])])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [_c('span', [_vm._v(_vm._s(o.estadoData.descripcion))])])]), _c('td', [_c('div', {
      staticClass: "td-wrapper"
    }, [(o.estado === 1 && !o.esSolicitudPasada) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.enterEditMode(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })]), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Enviar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : (o.estado === 2 && !o.esSolicitudPasada) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : (o.estado > 2) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('span', [_vm._v("No hay acciones")])]) : _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('span', {
      staticClass: "has-text-danger"
    }, [_vm._v("Solicitud no aprobada oportunamente, solicitar a RRHH que lo apruebe")])])])])]) : _vm._e()
  }), 0)], 1), (_vm.isLoading) ? _c('loading') : _vm._e()], 1)], 1) : _c('div', {
    key: "edit-solicitud"
  }, [_c('nueva-solicitud-vacaciones', {
    ref: "editarSolicitud",
    attrs: {
      "is-editing": true,
      "solicitud": _vm.solicitudSeleccionada
    },
    on: {
      "close": function($event) {
        _vm.isEditing = false
      },
      "closeRefresh": function($event) {
        _vm.isEditing = false;
        _vm.fetch();
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43fb2d14","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lista_Solicitud_Vacaciones_Component.vue
// module id = 875
// module chunks = 0